<div class="stage-config-card">
    <div class="stage-config-header">
        <h3 class="stage-config-title">Stage Configuration</h3>
        <button *ngIf="userPrivileges.has('event_stage.update') && stage.isEditable" class="config-edit-btn"
            (click)="openManageSchedule()" pTooltip="Edit" tooltipPosition="top">
            <em class="pi pi-pencil"></em>
        </button>
        <button *ngIf="userPrivileges.has('event_stage.update') && !stage.isEditable" class="config-edit-btn disabled"
            [disabled]="true" pTooltip="Candidate data exists. Editing not allowed" tooltipPosition="top">
            <em class="pi pi-pencil"></em>
        </button>
    </div>

    <div class="stage-config-content">
        <div class="config-item"
            *ngIf="stage.type === 'Assessment' || stage.type === 'Online Interview' || stage.type === 'Offline Interview' || stage.type === 'AI Interview' || stage.type === 'Documentation' || stage.type === 'Offer'">
            <div class="config-icon-wrapper feedback">
                <em class="pi pi-file"></em>
            </div>
            <div class="config-details">
                <span class="config-label">
                    <span *ngIf="stage.type === 'Assessment'">TEST SOURCE</span>
                    <span
                        *ngIf="stage.type === 'Online Interview' || stage.type === 'Offline Interview' || stage.type === 'AI Interview'">FEEDBACK
                        FORM</span>
                    <span *ngIf="stage.type === 'Documentation'">DOCUMENTATION FORM</span>
                    <span *ngIf="stage.type === 'Offer'">OFFER FORM</span>
                </span>
                <span class="config-value" *ngIf="showSummary">
                    <p-skeleton width="8rem" height="1rem" *ngIf="!formName && !contestName"></p-skeleton>
                    <span *ngIf="stage.type === 'Assessment'">{{ contestName }}</span>
                    <span *ngIf="stage.type !== 'Assessment'">{{ formName }}</span>
                </span>
                <span class="config-value config-not-mapped" *ngIf="userPrivileges.has('event_stage.update') && !showSummary && stage.type === 'Assessment'">
                    Test source not mapped yet. To map, click <a class="config-edit-link" (click)="openManageSchedule()">Edit</a> and map test.
                </span>
                <span class="config-value config-not-mapped" *ngIf="!userPrivileges.has('event_stage.update') && !showSummary && stage.type === 'Assessment'">
                    Test source not mapped yet 
                </span>
            </div>
        </div>

        <div class="config-item"
            *ngIf="(stage.type === 'Online Interview' || stage.type === 'Offline Interview' || stage.type === 'AI Interview') && stage.evaluation_criteria">
            <div class="config-icon-wrapper evaluation">
                <em class="pi pi-check-square"></em>
            </div>
            <div class="config-details">
                <span class="config-label">EVALUATION CRITERIA</span>
                <span class="config-value">{{ stage.evaluation_criteria }}</span>
            </div>
        </div>

        <div class="config-item" *ngIf="stage.type === 'AI Interview' && stage.ai_agent_uuid">
            <div class="config-icon-wrapper agent">
                <em class="pi pi-user"></em>
            </div>
            <div class="config-details">
                <span class="config-label">AGENT</span>
                <span class="config-value">
                    <p-skeleton width="6rem" height="1rem" *ngIf="agentsLoading"></p-skeleton>
                    <span *ngIf="!agentsLoading">{{ getAgentName() }}</span>
                </span>
            </div>
        </div>

        <!-- Email Template -->
        <div class="config-item"
            *ngIf="(stage.type === 'Online Interview' || stage.type === 'Documentation' || stage.type === 'Offer' || stage.type === 'Offline Interview' || stage.type === 'AI Interview') || (stage.type === 'Assessment' && !isWalkIn)">
            <div class="config-icon-wrapper email">
                <em class="pi pi-envelope"></em>
            </div>
            <div class="config-details">
                <span class="config-label">EMAIL TEMPLATE</span>
                <span class="config-value" *ngIf="showMailSummary">
                    <p-skeleton width="8rem" height="1rem" *ngIf="!selectedMailTemplate?.templateTitle"></p-skeleton>
                    <span *ngIf="selectedMailTemplate?.templateTitle">{{ selectedMailTemplate?.templateTitle }}</span>
                </span>
                <span class="config-value config-not-mapped" *ngIf="!showMailSummary">
                    Email template not mapped yet. To map, click <a class="config-edit-link" (click)="openManageSchedule()">Edit</a> and select template.
                </span>
            </div>
        </div>
    </div>
</div>


<p-dialog [visible]="showFormDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    [style]="{ width: '700px', maxWidth: '95vw' }" [baseZIndex]="0" class="neo-dialog">
    <div class="dialog-wrapper">
        <!-- Header -->
        <div class="dialog-header">
            <h2 class="dialog-title">Manage Stage Configuration</h2>
            <button type="button" class="dialog-close-btn" (click)="closeFormDialog()" aria-label="Close">
                <em class="pi pi-times"></em>
            </button>
        </div>

        <!-- Content -->
        <div class="dialog-content">
            <div class="content-wrapper">
                <form class="send-email-form">
                    <!-- Assessment Stage -->
                    <div class="form-field" *ngIf="stage.type == 'Assessment'">
                        <label class="field-label">Test Source <span class="required-asterisk">*</span></label>
                        <p-select class="form-dropdown" optionLabel="label" optionValue="value" [options]="testForms"
                            [(ngModel)]="selectedContest" [ngModelOptions]="{standalone: true}" [filter]="true"
                            filterBy="label" appendTo="body" placeholder="Choose a test">
                            <ng-template let-item pTemplate="item">
                                <div class="contest-dropdown-item">
                                    <span>{{ item.label }}</span>
                                    <span *ngIf="item.test_start_date" class="test-start-date-badge">
                                        {{ formatTestStartDate(item.test_start_date) }}
                                    </span>
                                </div>
                            </ng-template>
                        </p-select>
                    </div>

                    <!-- Walk-in mode toggle (Assessment only) -->
                    <div class="form-field" *ngIf="stage.type == 'Assessment'">
                        <div class="walkin-toggle-card" [class.active]="isWalkIn">
                            <div class="walkin-toggle-icon"><em class="pi pi-map-marker"></em></div>
                            <div class="walkin-toggle-text">
                                <span class="walkin-toggle-title">Walk-in mode</span>
                                <span class="walkin-toggle-hint">Candidates launch this assessment at a venue using a shared link + access key instead of an individual email link + OTP.</span>
                            </div>
                            <p-toggleswitch [(ngModel)]="isWalkIn" [ngModelOptions]="{standalone: true}"></p-toggleswitch>
                        </div>
                    </div>

                    <!-- Interview Stages -->
                    <ng-container
                        *ngIf="stage.type === 'Online Interview' || stage.type === 'Offline Interview' || stage.type === 'AI Interview'">
                        <div class="form-field">
                            <label class="field-label">Feedback Form <span class="required-asterisk" *ngIf="stage.type !== 'AI Interview'">*</span></label>
                            <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                                [options]="feedbackForms" [(ngModel)]="selectedForm"
                                [ngModelOptions]="{standalone: true}" placeholder="Choose a form" appendTo="body">
                            </p-select>
                        </div>

                        <div class="form-field">
                            <label class="field-label">Evaluation Criteria</label>
                            <textarea pInputTextarea class="form-input" [(ngModel)]="evaluationCriteria"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Enter evaluation criteria for this interview stage..." rows="4"
                                maxlength="1000" style="resize: vertical; min-height: 80px; height: auto;"></textarea>
                            <small class="character-counter"
                                [ngClass]="{'text-danger': evaluationCriteria.length >= 1000}">
                                {{ evaluationCriteria.length }} / 1000 characters
                            </small>
                        </div>

                        <div class="form-field" *ngIf="stage.type === 'AI Interview'">
                            <label class="field-label">Agent <span class="required-asterisk">*</span></label>
                            <p-select class="form-dropdown" [options]="agents" optionLabel="label" optionValue="value"
                                [(ngModel)]="selectedAgent" [ngModelOptions]="{standalone: true}"
                                [showClear]="!!selectedAgent && selectedAgent !== ''" [loading]="agentsLoading"
                                appendTo="body" placeholder="Select Agent">
                            </p-select>
                        </div>
                    </ng-container>

                    <!-- Documentation Stage -->
                    <div class="form-field" *ngIf="stage.type == 'Documentation'">
                        <label class="field-label">Documentation Form <span class="required-asterisk">*</span></label>
                        <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                            [options]="documentationForms" [(ngModel)]="selectedForm"
                            [ngModelOptions]="{standalone: true}" placeholder="Choose a form" appendTo="body">
                        </p-select>
                    </div>

                    <!-- Offer Stage -->
                    <div class="form-field" *ngIf="stage.type == 'Offer'">
                        <label class="field-label">Offer Form <span class="required-asterisk">*</span></label>
                        <p-select class="form-dropdown" optionLabel="label" optionValue="value" [options]="offerForms"
                            [(ngModel)]="selectedForm" [ngModelOptions]="{standalone: true}" placeholder="Choose a form"
                            appendTo="body">
                        </p-select>
                    </div>

                    <!-- Email Template (hidden for walk-in Assessment stages — no candidate email) -->
                    <div class="form-field" *ngIf="!(stage.type === 'Assessment' && isWalkIn)">
                        <label class="field-label">Email Template <span class="required-asterisk">*</span></label>
                        <p-select class="form-dropdown" optionLabel="name" [options]="EmailTemplateOptions"
                            [(ngModel)]="selectedMailTemplateId" [ngModelOptions]="{standalone: true}" appendTo="body"
                            (onChange)="getSelectedMailTemplate(selectedMailTemplateId)"
                            placeholder="Select a template">
                        </p-select>
                        <span class="error-paceholder p-error" *ngIf="errorPlaceholder.length">
                            Please select a template with the following placeholders:
                            <div *ngFor="let data of errorPlaceholder; let i = index">
                                <span>{{ i + 1 }}. {{ data }}</span>
                            </div>
                        </span>
                    </div>

                    <div class="form-field"
                        *ngIf="selectedMailTemplate?.templateTitle && errorPlaceholder.length === 0 && !(stage.type === 'Assessment' && isWalkIn)">
                        <label class="field-label">Email Preview</label>
                        <div class="email-preview-box"
                            [innerHTML]="selectedMailTemplate?.templateContent | getSafeHTMLEmail"></div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Footer -->
        <div class="dialog-footer">
            <button type="button" class="cancel-btn" (click)="closeFormDialog()">Cancel</button>
            <button type="button" class="save-btn" (click)="saveStageManageContent()" [disabled]="manageContentLoad ||
                (stage.type === 'Assessment' && (!selectedContest || (!isWalkIn && !(selectedMailTemplateId?.id || stage?.email_template?.id)))) ||
                ((stage.type === 'Online Interview' || stage.type === 'Offline Interview' || stage.type === 'Documentation' || stage.type === 'Offer') && (!selectedForm || !(selectedMailTemplateId?.id || stage?.email_template?.id))) ||
                (stage.type === 'AI Interview' && (!selectedAgent || !(selectedMailTemplateId?.id || stage?.email_template?.id))) ||
                errorPlaceholder.length > 0">
                <span *ngIf="!manageContentLoad">Save</span>
                <em *ngIf="manageContentLoad" class="pi pi-spin pi-spinner"></em>
            </button>
        </div>
    </div>
</p-dialog>